import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../../loading.service';
import { SignAssociationControllerRequestService } from '../sign-association-controller-request.service';
import { SignPhoneNumberAdjustment } from '../../../../model/sign/phone/sign-phone-number-adjustment';
import { SignPhoneNumberAdjustmentOverview } from '../../../../model/sign/phone/sign-phone-number-adjustment-overview';
import { SnackService } from '../../../snack.service';

@Injectable({
  providedIn: 'root',
})
export class SignPhoneNumberAdjustmentControllerRequestService extends SignAssociationControllerRequestService<
  SignPhoneNumberAdjustment,
  SignPhoneNumberAdjustmentOverview
> {
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    super(
      http,
      snackService,
      loadingService,
      router,
      '/signphonenumberadjustments'
    );
  }

  protected override deserializeImpl(): (
    res: any
  ) => SignPhoneNumberAdjustment {
    return (res) => res as SignPhoneNumberAdjustment;
  }
}
